
import { defineComponent, PropType } from "vue";

import Road from "@/models/Road";
import Port from "@/models/Port";

import BoardPort from "@/components/Board/BoardPort.vue";

export default defineComponent({
  inject: ["game"],
  props: {
    corners: { type: Array as PropType<number[]>, required: true },
    road: { type: [Object, null] as PropType<Road | null>, required: true },
    direction: { type: Number as PropType<0 | 1 | 2> },
  },
  computed: {
    activePlayerId(): number {
      return this.game.activePlayerId!;
    },
    buildingRoad(): boolean {
      return this.game.isBuildingRoad;
    },
    className(): string[] {
      const classes = [`edge-direction-${this.direction}`];

      if (this.road !== null) {
        classes.push("edge-road", `edge-player-${this.road.player}`);
      } else if (this.buildingRoad) {
        classes.push(
          "edge-building-road",
          `edge-player-${this.activePlayerId}`
        );
      }
      return classes;
    },
    port(): Port | boolean {
      if (this.game.publicState) {
        const corner1 = this.game.publicState.board.corners.find(
          ({ id }) => id === this.corners[0]
        );
        if (corner1 && corner1.port !== null) {
          const corner2 = this.game.publicState.board.corners.find(
            ({ id }) => id === this.corners[1]
          );
          if (corner2 && corner2.port !== null) {
            return corner1.port;
          }
        }
      }
      return false;
    },
    reversePort(): boolean {
      return (
        this.corners[0] === 32 ||
        this.corners[0] === 34 ||
        (this.corners[0] >= 36 && this.corners[0] < 47) ||
        this.corners[0] === 48 ||
        this.corners[0] === 50
      );
    },
  },
  methods: {
    handleClick() {
      if (this.buildingRoad && this.road === null) {
        this.game.buildRoad([this.corners[0], this.corners[1]]);
      }
    },
  },
  components: { BoardPort },
});
